import store from "./store";
import get from "./get";
import update from "./update";
import destroy from "./destroy";
import getStatuses from "./getStatuses";
import assignMemberToCheckedTasks from "./assignMemberToCheckedTasks";

export default {
  store,
  get,
  update,
  destroy,
  getStatuses,
  assignMemberToCheckedTasks
}



// WEBPACK FOOTER //
// ./src/app/services/task/index.js